import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { CDATAConnectorInfo, CDATA_TYPE_LIST, CDataConnectorSetting, CDataDBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../basedatasource.panel';

@Component({
    selector: 'generic-cdata-panel',
    templateUrl: './generic.cdata.panel.html'
})
export class GenericCDATAPanel extends BaseDataSourcePanel implements AfterViewInit {

    Subscription;
    ConnectorTypes = [...CDATA_TYPE_LIST];
    @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: GenericCDATAPanel,
            DBInfoType: CDataDBInfo
        };
    }

    constructor() {
        super();
        this.DBInfoType = CDataDBInfo;
    }

    ngAfterViewInit(): void {
        if (this.DBInfo && this.DBInfo.ConnectionType) {
            const info = CDATA_TYPE_LIST.find(x => x.Type == this.DBInfo.ConnectionType);
            if (info) {
                if (!this.DBInfo.ConnectorSettings) {
                    this.DBInfo.ConnectorSettings = new CDataConnectorSetting(info.Type);
                }
                this.setComponent(info);
            }
        }
    }

    onUserDefinedSwitch() {
        this.onChange(null);
        this.onDataSourceSet();
    }

    onDataSourceSet() {
        if (this.DBInfo && this.DBInfo.ConnectionType) {
            const info = CDATA_TYPE_LIST.find(x => x.Type == this.DBInfo.ConnectionType);
            if (info) {
                this.DBInfo.ConnectorSettings = new CDataConnectorSetting(info.Type);
                if (this.DBInfo.Connection) {
                    Object.assign(this.DBInfo.ConnectorSettings, JSON.parse(this.DBInfo.Connection));
                } else if (info.Default) {
                    Object.assign(this.DBInfo.ConnectorSettings, info.Default);
                }
            } else {
                this.DBInfo.Connection = null;
                this.DBInfo.ConnectionType = null;
                this.DBInfo.ConnectorSettings = null;
                this.DBInfo.InteractiveProperties = [];
            }
            this.setComponent(info);
        }
    }

    setComponent(info: CDATAConnectorInfo) {
        if (this.Subscription) {
            this.Subscription.unsubscribe();
        }
        if (this.viewContainerRef) {
            this.viewContainerRef.clear();
            if (info) {                
                const comp = this.viewContainerRef.createComponent(info.ControlType);
                const component: any = comp.instance;
                if (component) {
                    component.Settings = this.DBInfo.ConnectorSettings;
                    component.DataSource = this.DataSourceValue;
                    component.DBInfo = this.DBInfo;
                    this.Subscription = component.OnDataChange.subscribe(() => { this.onChange(null); });
                }
            }
        }
    }

    onConnectorChanged() {
        if (this.DBInfo) {
            this.DBInfo.Connection = null;
            this.DBInfo.ConnectorSettings = null;
            this.DBInfo.InteractiveProperties = [];
        }
        this.onDataSourceSet();
        this.onChange(null);
    }
}
